import { userConstants } from '../constants';

export const userReducer = (state = {}, action) => {
    // delete password for security
    if(action && action.payload && action.payload.hasOwnProperty('password')) delete action.payload.password;

    switch(action.type) {
        case userConstants.GET_ALL_USERS_REQEUST:
            return {
                ...state,
                getAllUsersProcess: true
            }

        case userConstants.GET_ALL_USERS_SUCCESS: 
            return {
                ...state,
                list: action.payload,
                getAllUsersProcess: false,  
                getAllUsersError: false
            }

        case userConstants.GET_ALL_USERS_FAILURE: 
            return {
                ...state,
                getAllUsersProcess: false,
                getAllUsersError: true
            }

        case userConstants.GET_USER_ACCOUNT_ACCESS_REQEUST:
            return {
                ...state,
                getUserAccountAccessProcess: true
            }

        case userConstants.GET_USER_ACCOUNT_ACCESS_SUCCESS: 
            return {
                ...state,
                getUserAccountAccessProcess: false,  
                getUserAccountAccessError: false
            }

        case userConstants.GET_USER_ACCOUNT_ACCESS_FAILURE: 
            return {
                ...state,
                getUserAccountAccessProcess: false,
                getUserAccountAccessError: true
            }

        default: 
            return state;
    }
}

export default userReducer;


// WEBPACK FOOTER //
// ./src/reducers/user.js